import {
  faExclamationCircle,
  faWrench,
} from "@fortawesome/pro-solid-svg-icons";
import { Stack } from "@mui/material";

import { Alert, Divider, Icon, Link, Typography } from "@/components/ui-v2";
import { useBasicData, useIncidents, useMaintenances } from "@/hooks";

const DEFAULT_INCIDENT_TITLE =
  "Our team is investigating an issue that may affect your experience.";
const DEFAULT_MAINTENANCE_TITLE = "Layer has scheduled maintenance.";

export const AppWarnings = () => {
  const { workspace, error } = useBasicData();
  const { incidents } = useIncidents();
  const { maintenances } = useMaintenances();

  if (error || !workspace) {
    return null;
  }

  // An incident outranks a maintenance, which is planned and so announced rather than warned about.
  const currentIncident = incidents?.[0];
  const currentNotice = currentIncident ?? maintenances?.[0];
  if (!currentNotice) {
    return null;
  }

  return (
    <Alert
      severity={currentIncident ? "warning" : "info"}
      icon={
        <Icon
          icon={currentIncident ? faExclamationCircle : faWrench}
          size="small"
        />
      }
    >
      <Stack spacing={1} divider={<Divider />}>
        <Typography variant="caption" fontWeight={700}>
          {currentNotice.name ||
            (currentIncident
              ? DEFAULT_INCIDENT_TITLE
              : DEFAULT_MAINTENANCE_TITLE)}
        </Typography>
        <Typography variant="caption">
          <span>
            You can follow the status of this{" "}
            {currentIncident ? "incident" : "maintenance"}{" "}
          </span>
          <Link
            href={currentNotice.url}
            sx={{ fontWeight: "bold", textDecoration: "underline" }}
          >
            here
          </Link>
          <span>.</span>
        </Typography>
      </Stack>
    </Alert>
  );
};
